import { MethodType } from '../constants/MethodType'
const api = require('./api')

export const fetchTaxonomyTree = (id, params) => api.request(1, `/taxonomyTree/${id}`, MethodType.GET, params)

export const addTaxonomy = params => api.request(1, '/taxonomys', MethodType.POST, params)

export const modifyTaxonomy = (id, params) => api.request(1, `/taxonomys/${id}`, MethodType.PUT, params)

export const deleteTaxonomy = (id, params) => api.request(1, `/taxonomys/${id}`, MethodType.DELETE, params)
